<template>
	<div class="cookie__container">
		<div class="cookie__wrapper">
			<p>Мы используем cookie, чтобы улучшить ваше взаимодействие с сайтом</p>
			<button class="button" @click="$emit('submit')">Ок, закрыть</button>
		</div>
	</div>
</template>

<script setup lang="ts">
	const $emit = defineEmits<{
		(e: 'submit'): void;
	}>();
</script>

<style lang="scss" scoped>
	.cookie__container {
		z-index: 10;
		position: fixed;
		left: 0;
		right: 0;
		bottom: 0;
		width: 100%;
		padding: 0px var(--layout-padding) 10px;
	}
	.cookie__wrapper {
		display: flex;
		align-items: center;
		flex-direction: column;
		gap: 20px;
		max-width: 700px;
		margin: 0 auto;
		color: var(--color-white);
		background-color: var(--color-black);
		padding: 30px;
		border-radius: 20px;
	}
</style>
